import(/* webpackMode: "eager" */ "/vercel/path0/app/service/seo/seo.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/service/seo/rag.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/ui-utilities.scss");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
